import {
  Alert,
  Paragraph,
  Stack,
  Wizard,
  useWizardPage,
  Title
} from '@efast_public/fjd-component-library';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { WeiterleitungsWizardState } from '../../../../modals/ReceiverSettingsWizard/Wizard.types';
import { SyncResultDto } from '../../../../api/hooks/useSyncResult';

function Summary() {
  const { t } = useTranslation();

  const { wizardState } = useWizardPage({
    headline: (state) =>
      `Schritt ${state.currentPageIndex + 1} von ${state.pagesLength}`,
    primaryButtonLabel: t('configAssistent.summary.primaryButton')
  });

  const state = wizardState.state as WeiterleitungsWizardState | undefined;
  const syncResult: SyncResultDto | undefined = state?.syncResult;

  return (
    <Wizard.Page>
      <Stack direction="column" spacing="xs">
        <Title level={2} visualLevel={6}>
          {t('configAssistent.summary.headline')}
        </Title>
        <Paragraph>{t('configAssistent.summary.descriptionText')}</Paragraph>
        <Alert
          message={t('receiverSettingsWizard.summary.fitCoSuccess')}
          variant="success"
        />
        {syncResult && (
          <Stack direction="column" spacing="xs">
            {syncResult.importedOrgUnitNames.length > 0 && (
              <Alert
                variant="success"
                message={t('receiverSettingsWizard.summary.importedOrgUnits', {
                  names: syncResult.importedOrgUnitNames.join(', '),
                  count: syncResult.importedOrgUnitNames.length
                })}
              />
            )}
            {syncResult.deactivatedOrgUnitNames.length > 0 && (
              <Alert
                variant="warning"
                message={t(
                  'receiverSettingsWizard.summary.deactivatedOrgUnits',
                  {
                    names: syncResult.deactivatedOrgUnitNames.join(', '),
                    count: syncResult.deactivatedOrgUnitNames.length
                  }
                )}
              />
            )}
            {syncResult.deletedOrgUnitNames.length > 0 && (
              <Alert
                variant="warning"
                message={t('receiverSettingsWizard.summary.deletedOrgUnits', {
                  names: syncResult.deletedOrgUnitNames.join(', '),
                  count: syncResult.deletedOrgUnitNames.length
                })}
              />
            )}
            {syncResult.addedPublicServices.length > 0 && (
              <Alert
                variant="success"
                message={t(
                  'receiverSettingsWizard.summary.addedPublicServices',
                  { count: syncResult.addedPublicServices.length }
                )}
              />
            )}
            {syncResult.removedPublicServices.length > 0 && (
              <Alert
                variant="warning"
                message={t(
                  'receiverSettingsWizard.summary.removedPublicServices',
                  { count: syncResult.removedPublicServices.length }
                )}
              />
            )}
            {syncResult.newlyImported.length > 0 && (
              <Alert
                variant="success"
                message={t('receiverSettingsWizard.summary.addedSchemaUris', {
                  total: syncResult.newlyImported.length
                })}
              />
            )}
            {syncResult.syncStatus.some((s) => !s.dataAvailable) && (
              <Alert
                variant="warning"
                message={t('receiverSettingsWizard.summary.updatedSchemaUris', {
                  pending: syncResult.syncStatus.filter((s) => !s.dataAvailable)
                    .length,
                  total: syncResult.syncStatus.length
                })}
              />
            )}
            {syncResult.importedOrgUnitNames.length === 0 &&
              syncResult.deactivatedOrgUnitNames.length === 0 &&
              syncResult.deletedOrgUnitNames.length === 0 &&
              syncResult.addedPublicServices.length === 0 &&
              syncResult.removedPublicServices.length === 0 &&
              syncResult.newlyImported.length === 0 &&
              !syncResult.syncStatus.some((s) => !s.dataAvailable) && (
                <Alert
                  variant="info"
                  message={t('receiverSettingsWizard.summary.noChanges')}
                />
              )}
          </Stack>
        )}
      </Stack>
    </Wizard.Page>
  );
}

export default Summary;
